/**
 * @voltxampere/ui — Passive piezo buzzer 5V (Sprint 51-1 polish)
 *
 * Passive piezo transducer — needs an external square-wave / PWM
 * signal to produce sound. Frequency-controllable from 100 Hz to
 * 5 kHz. Used in melody players, frequency-shift keying, Arduino
 * tone() output.
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const buzzerPassive = {
    id: "buzzer-passive-5v",
    nameTr: "Pasif Piezo Buzzer 5V (PWM kontrollü)",
    nameEn: "Passive Piezo Buzzer 5V (PWM controlled)",
    shortcut: "B",
    category: "active",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "BZ",
    defaultValue: "5V Passive",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 0,
        deviceType: "piezo-buzzer-passive",
        operatingV: 5,
        typicalCurrentMa: 25,
        frequencyRangeHz: { min: 100, max: 5000 },
        requiresPwm: true,
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=buzzer-passive.js.map